import { render } from "./ViewAccessories.vue?vue&type=template&id=4eec6bbc"
import script from "./ViewAccessories.vue?vue&type=script&lang=js"
export * from "./ViewAccessories.vue?vue&type=script&lang=js"

import "./ViewAccessories.vue?vue&type=style&index=0&id=4eec6bbc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__